import { STYLES_COLOR } from 'modules/styles/constants/index.cjs'

/**
 * The menu's domain.
 * @type {string}
 */
const MENU_DOMAIN = 'menu'
/**
 * The menu's initial state.
 * @type {Object}
 */
const MENU_STATE = {
  current: null,
  /**
   * A mapping of menu label to action callback.
   * @type {Object}
   */
  action: null,
  /**
   * A mapping of menu label to action label.
   * @type {Object}
   */
  navigation: null
}

/**
 * The menu's paths.
 * @type {Object}
 */
const MENU_PATH = {
  CURRENT: `${MENU_DOMAIN}.current`,
  ACTION: `${MENU_DOMAIN}.action`,
  NAVIGATION: `${MENU_DOMAIN}.navigation`
}

/**
 * A mapping of key to menu id.
 * @type {Object}
 */
const MENU_ID = {
  ACTION: 'MENU_ACTION',
  NAVIGATION: 'MENU_NAVIGATION'
}

/**
 * A mapping of action key to action id.
 * @type {Object}
 */
const MENU_ACTION_ID = {
  CART_ADD_PRODUCT: 'MENU_ACTION_CART_ADD_PRODUCT',
  CART_CHECKOUT: 'MENU_ACTION_CART_CHECKOUT',
  CHECKOUT_PLACE_ORDER: 'MENU_ACTION_CHECKOUT_PLACE_ORDER',
  CHECKOUT_UPDATE_ADDRESS: 'MENU_ACTION_CHECKOUT_UPDATE_ADDRESS',
  MODEL_EDIT: 'MENU_ACTION_MODEL_EDIT',
  MODEL_DISCARD: 'MENU_ACTION_MODEL_DISCARD',
  MODEL_DONE: 'MENU_ACTION_MODEL_DONE',
  MODEL_DELETE: 'MENU_ACTION_MODEL_DELETE',
  MODEL_SAVE: 'MENU_ACTION_MODEL_SAVE',
  ORDER_CANCEL: 'MENU_ACTION_ORDER_CANCEL',
  USER_SIGNIN: 'MENU_ACTION_USER_SIGNIN',
  USER_SIGNOUT: 'MENU_ACTION_USER_SIGNOUT'
}

/**
 * A mapping of action key to action id.
 * @type {Object}
 */
const MENU_NAVIGATION_ID = {
  CART: 'MENU_NAVIGATION_CART',
  TRAINING: 'MENU_NAVIGATION_TRAINING',
  STORE: 'MENU_NAVIGATION_STORE',
  EMAILS: 'MENU_NAVIGATION_EMAILS',
  LOGS: 'MENU_NAVIGATION_LOGS',
  ORDERS: 'MENU_NAVIGATION_ORDERS',
  // SETTINGS : 'MENU_NAVIGATION_SETTINGS',
  ARTICLES: 'MENU_NAVIGATION_ARTICLES',
  MOTIVATION: 'MENU_NAVIGATION_MOTIVATION',
  COMPANY: 'MENU_NAVIGATION_COMPANY',
  SUPPORT: 'MENU_NAVIGATION_SUPPORT'
}

/**
 * A mapping of menu id to a mapping of key to label.
 * @type {Object}
 */
const MENU_LABEL = {
  [MENU_ACTION_ID.CART_ADD_PRODUCT]: 'Add',
  [MENU_ACTION_ID.CART_CHECKOUT]: 'Checkout',
  [MENU_ACTION_ID.CHECKOUT_PLACE_ORDER]: 'Place',
  [MENU_ACTION_ID.CHECKOUT_UPDATE_ADDRESS]: 'Update',
  [MENU_ACTION_ID.MODEL_EDIT]: 'Edit',
  [MENU_ACTION_ID.MODEL_DISCARD]: 'Discard',
  [MENU_ACTION_ID.MODEL_DONE]: 'Done',
  [MENU_ACTION_ID.MODEL_DELETE]: 'Delete',
  [MENU_ACTION_ID.MODEL_SAVE]: 'Save',
  [MENU_ACTION_ID.ORDER_CANCEL]: 'Cancel',
  [MENU_ACTION_ID.USER_SIGNIN]: 'Sign In',
  [MENU_ACTION_ID.USER_SIGNOUT]: 'Signout',
  [MENU_NAVIGATION_ID.CART]: 'Cart',
  [MENU_NAVIGATION_ID.TRAINING]: 'Training',
  [MENU_NAVIGATION_ID.STORE]: 'Store',
  [MENU_NAVIGATION_ID.EMAILS]: 'Emails',
  [MENU_NAVIGATION_ID.LOGS]: 'Logs',
  [MENU_NAVIGATION_ID.HOME]: 'Home',
  [MENU_NAVIGATION_ID.ORDERS]: 'Orders',
  [MENU_NAVIGATION_ID.ARTICLES]: 'Articles',
  [MENU_NAVIGATION_ID.MOTIVATION]: 'Motivation',
  [MENU_NAVIGATION_ID.COMPANY]: 'Company',
  [MENU_NAVIGATION_ID.SUPPORT]: 'Support'
}

/**
 * A mapping of menu id to a mapping of key to label.
 * @type {Object}
 */
const MENU_COLOR = {
  [MENU_ACTION_ID.MODEL_DELETE]: STYLES_COLOR.RED,
  [MENU_ACTION_ID.USER_SIGNOUT]: STYLES_COLOR.RED
}

export {
  MENU_DOMAIN,
  MENU_STATE,
  MENU_PATH,
  MENU_ID,
  MENU_ACTION_ID,
  MENU_NAVIGATION_ID,
  MENU_LABEL,
  MENU_COLOR
}
